import { useTranslation } from 'react-i18next';

const EncStatusCell: React.FC<{ status: string }> = ({ status }) => {
  const defaultStatus = `text-${status} ri-checkbox-blank-circle-fill`;
  const { t } = useTranslation();
  return (
    <span className="fs-3 text-center">
      <i
        className={defaultStatus}
        title={
          status === 'danger' ? t('ObjectVuls.table.statusTooltip.danger') : t('ObjectVuls.table.statusTooltip.success')
        }
      />
    </span>
  );
};

export default EncStatusCell;
